/**
 * @file Network status indicator component
 */
import React, { useState, useEffect } from 'react';

const NetworkStatus: React.FC = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => {
            console.log('[NetworkStatus] Connection restored');
            setIsOnline(true);
        };

        const handleOffline = () => {
            console.log('[NetworkStatus] Connection lost');
            setIsOnline(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline) {
        return null; // Don't show anything when online
    }

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: '#ff9800',
            color: 'white',
            padding: '10px',
            textAlign: 'center',
            zIndex: 1000,
            fontSize: '14px'
        }}>
            📡 Sin conexión a internet. Verifica tu conexión y vuelve a intentar.
        </div>
    );
};

export default NetworkStatus;
